import { Box, styled } from "@mui/material";

const StyledClientCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    boxSizing: "border-box",
    borderRadius: (theme as any).shape.border.general.radius[4],
    backgroundColor: (theme as any).palette.neutral.darkest,
    border: "1px solid rgba(255, 255, 255, 0.06)",
    width: '100%',
}))

export { StyledClientCard }

